import {
  AccountType,
  postV1CompaniesCompanyIdAccountsConnected,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import { Account } from '~hooks/useAccount/models';
import connection from '~services/connectionModule';

interface CreateConnectedAccountByTreadIdParams {
  receiverTreadId: string;
  senderCompanyId: string;
  accountTypes: AccountType[];
}

export default function useAccountsAdmin() {
  const createConnectedAccountByTreadId = useCallback(
    async ({
      senderCompanyId,
      receiverTreadId,
      accountTypes,
    }: CreateConnectedAccountByTreadIdParams) => {
      try {
        const response = await postV1CompaniesCompanyIdAccountsConnected({
          path: { 'company-id': senderCompanyId },
          body: {
            tread_id: receiverTreadId,
            account_types: accountTypes,
          },
        });

        return Account.parse(response.data.data);
      } catch (error) {
        connection.handleRequestError(
          error,
          t('error_messages.account.failed_to_create_connected'),
        );
        throw error;
      }
    },
    [],
  );

  return { createConnectedAccountByTreadId };
}
